import React, { useState } from "react";
import { downloadAdmitCard } from "../../utils/downloadAdmitCard";
import { downloadApplication } from "../../utils/downloadApplication";

const ApplicationCard = ({ item, isPendingPayment, onPayNow, onContinue }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingApplication, setIsDownloadingApplication] = useState(false);

  const handleDownloadAdmitCard = async () => {
    setIsDownloading(true); // Show loading state
    const token = localStorage.getItem("parentToken");

    try {
      await downloadAdmitCard(item.detailsUrl, token);
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to download admit card. Please try again.");
    } finally {
      setIsDownloading(false); // Hide loading state
    }
  };

  const handleDownloadApplication = async () => {
    setIsDownloadingApplication(true);
    const token = localStorage.getItem("parentToken");

    try {
      await downloadApplication(item.detailsUrl, token);
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to download application. Please try again.");
    } finally {
      setIsDownloadingApplication(false);
    }
  };

  return (
    <div className="p-6 border rounded-lg shadow-md bg-white">
      {/* Title for Normal Data */}
      {!isPendingPayment && (
        <h3 className="text-xl font-semibold text-blue-700">
          {item.first_name && item.last_name
            ? `${item.first_name} ${item.last_name}`
            : "No Name"}
        </h3>
      )}

      {/* Title for Pending Payments */}
      {isPendingPayment && (
        <h3 className="text-xl font-semibold text-red-600">
          Pending Payment: {item.type}
        </h3>
      )}

      {/* Common Fields */}
      <p className="text-gray-600 mt-2">
        {isPendingPayment ? "Amount: " + item.amount : "" + ""}
      </p>
      <p className="text-gray-600">
        Status:{" "}
        <span
          className={`font-semibold ${item.status === "Approved"
            ? "text-green-500"
            : item.status === "Pending"
              ? "text-yellow-500"
              : "text-red-500"
            }`}
        >
          {item.status}
        </span>
      </p>

      {/* Additional Fields for Pending Payments */}
      {isPendingPayment && item.admission && (
        <>
          <p className="text-gray-500">
            Student Name:{" "}
            {item.admission.first_name && item.admission.last_name
              ? `${item.admission.first_name} ${item.admission.last_name}`
              : "No Name"}
          </p>
          <p className="text-gray-500">Class: {item.admission.class.name}</p>
        </>
      )}

      {!isPendingPayment && (
        <>
          {item.application_no && ( // Show only if not null
            <p className="text-gray-500">
              Application No: {item.application_no}
            </p>
          )}

          <p className="text-gray-500">
            Student Name:{" "}
            {item.first_name && item.last_name
              ? `${item.first_name} ${item.last_name}`
              : "No Name"}
          </p>

          {item.class?.name && ( // Check if class and name exist
            <p className="text-gray-500">Class: {item.class.name}</p>
          )}
        </>
      )}

      {/* Conditional Buttons */}
      {!isPendingPayment && (
        <div className="mt-4">
          {item.status === "Approved" && item.detailsUrl && (
            <>
              <button
                onClick={handleDownloadAdmitCard}
                disabled={isDownloading}
                className="block w-full px-4 py-2 text-center text-white bg-green-600 rounded-lg hover:bg-green-700 transition"
              >
                {isDownloading ? "Downloading..." : "Download Admit Card"}
              </button>
              <button
                onClick={handleDownloadApplication}
                disabled={isDownloadingApplication}
                className="block w-full mt-2 px-4 py-2 text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
              >
                {isDownloadingApplication ? "Downloading..." : "Download Application"}
              </button>
            </>
          )}
          {item.status === "Pending" && (
            <button
              onClick={() => onContinue(item.detailsUrl, item.id)}
              className="block w-full px-4 py-2 text-center text-white bg-yellow-600 rounded-lg hover:bg-yellow-700 transition"
            >
              Continue Application
            </button>
          )}

          {/* No button for Rejected status */}
        </div>
      )}

      {/* Pay Now Button for Pending Payments */}
      {isPendingPayment && (
        <button
          onClick={() => onPayNow(item.admission_id, true)}
          className="block w-full mt-4 px-4 py-2 text-center text-white bg-red-600 rounded-lg hover:bg-red-700 transition"
        >
          Pay Now
        </button>
      )}
    </div>
  );
};

export default ApplicationCard;